const envKeys = {
    savedId: process.env.REACT_APP_SAVED_ID,
    userInfoKey: process.env.REACT_APP_USER_INFO_KEY,
    cryptoKey: process.env.REACT_APP_CRYPTO_KEY,
    cryptoIv: process.env.REACT_APP_CRYPTO_IV,
    serviceCode: process.env.REACT_APP_SERVICE_CODE,
};
Object.freeze(envKeys);
export default envKeys;
